export default {
  pt: {
    'shipments.historicoViagemDialog.title': 'Histórico da viagem',
    'shipments.historicoViagemDialog.loadNumber': 'Carga {{number}}',
    'shipments.historicoViagemDialog.empty': 'Sem eventos para esta viagem.',
    'shipments.historicoViagemDialog.noteOpened': 'Observação aberta',
    'shipments.historicoViagemDialog.noteResolved': 'Observação resolvida',
    'shipments.historicoViagemDialog.rescheduled': 'Reagendada em massa',
    'shipments.historicoViagemDialog.status.scheduled': 'Escalado',
    'shipments.historicoViagemDialog.status.loading': 'Carregando',
    'shipments.historicoViagemDialog.status.transit': 'Trânsito',
    'shipments.historicoViagemDialog.status.unloading': 'Descarregando',
    'shipments.historicoViagemDialog.status.attended': 'Atendido',
    'shipments.historicoViagemDialog.status.unattended': 'Não atendido',
  },
  en: {
    'shipments.historicoViagemDialog.title': 'Trip history',
    'shipments.historicoViagemDialog.loadNumber': 'Load {{number}}',
    'shipments.historicoViagemDialog.empty': 'No events for this trip.',
    'shipments.historicoViagemDialog.noteOpened': 'Note opened',
    'shipments.historicoViagemDialog.noteResolved': 'Note resolved',
    'shipments.historicoViagemDialog.rescheduled': 'Rescheduled in bulk',
    'shipments.historicoViagemDialog.status.scheduled': 'Scheduled',
    'shipments.historicoViagemDialog.status.loading': 'Loading',
    'shipments.historicoViagemDialog.status.transit': 'In transit',
    'shipments.historicoViagemDialog.status.unloading': 'Unloading',
    'shipments.historicoViagemDialog.status.attended': 'Attended',
    'shipments.historicoViagemDialog.status.unattended': 'Unattended',
  },
  es: {
    'shipments.historicoViagemDialog.title': 'Historial del viaje',
    'shipments.historicoViagemDialog.loadNumber': 'Carga {{number}}',
    'shipments.historicoViagemDialog.empty': 'No hay eventos para este viaje.',
    'shipments.historicoViagemDialog.noteOpened': 'Observación abierta',
    'shipments.historicoViagemDialog.noteResolved': 'Observación resuelta',
    'shipments.historicoViagemDialog.rescheduled': 'Reprogramado en lote',
    'shipments.historicoViagemDialog.status.scheduled': 'Programado',
    'shipments.historicoViagemDialog.status.loading': 'Cargando',
    'shipments.historicoViagemDialog.status.transit': 'En tránsito',
    'shipments.historicoViagemDialog.status.unloading': 'Descargando',
    'shipments.historicoViagemDialog.status.attended': 'Atendido',
    'shipments.historicoViagemDialog.status.unattended': 'No atendido',
  },
}
